import React from 'react';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import locales from '../../locales/LocalesManager';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import appParameters from '../../components/utils/AppParameters';
import platformDetection from '../utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import modeType from '../../constants/ModeConstants';
import { changeContextMode } from '../../actions/MenuActions';
import mindMapUtils from '../utils/MindMapUtils';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
        mindMapUtils.reset();
    },
    shouldComponentUpdate(newProps) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        let caption = locales.getCaption('MindMapMenuTitle', 'other');
        let closeButtonStyle = {
            position: 'absolute',
            right: 28,
            top: 4,
            width: 22,
            height: 22,
            cursor: 'pointer',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            background: 'none',
            borderStyle: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            right: 3,
            cursor: 'pointer'
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{caption}</span>
                <button id="firstFocusableObjectMindMapMenu" style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.insertNode();
    },
    onClick() {
        let downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.insertNode();
    },
    insertNode() {
        if (this.props.index === 0)
            mindMapUtils.insertTextNode();
        else
            mindMapUtils.openSearch();
    },
    render() {
        const width = properties.MOOD_ITEM_SIZE;
        const textHeight = 20;
        const height = width * 3/4 + textHeight;

        const buttonStyle = {
            position: 'absolute',
            top: this.props.index * height + (this.props.index + 1) * properties.MOOD_ITEM_GAP,
            left: (this.props.accordionWidth - properties.MOOD_ITEM_SIZE) / 2,
            width: width,
            height: height,
            background: '#f3f3f3',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            cursor: 'pointer'
        };

        let borderColor;
        let iconColor = 'black';

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            iconColor = borderColor;
        } else
            borderColor = properties.SLIDE_VIEWER_BACKGROUND;

        const borderWidth = 2;

        const frameStyle = {
            width: width - 2 * borderWidth,
            height: height - 2 * borderWidth,
            borderWidth: borderWidth,
            borderStyle: 'solid',
            borderColor: borderColor,
            position: 'absolute',
            top: 0,
            cursor: 'pointer'
        };

        const textPadding = 3;

        const titleStyle = {
            fontSize: 16,
            height: textHeight,
            width: width - 2 * textPadding,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            position: 'absolute',
            left: textPadding,
            top: 10,
            cursor: 'pointer',
            color: iconColor
        };

        var iconStyle = {
            position: 'absolute',
            top: 30,
            left: 32,
            color: iconColor,
            fontSize: 100
        };

        let idValue;
        let text;
        let icon = 'fa fa-picture-o';

        if (this.props.index === 1) {
            idValue = 'mindMapLastItem';
            text = locales.getCaption('MindMapSetImageNode', 'other');
        } else {
            text = locales.getCaption('MindMapSetTextNode', 'other');
            icon = 'fa fa-commenting-o';
        }

        return (
            <button id={idValue} aria-label={text} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp} onClick={this.onClick}>
                <span style={titleStyle}>{text}</span>
                <i style={iconStyle} className={icon}></i>
                <div style={frameStyle} />
            </button>
        );
    }
});

export const MindMapMenu = React.createClass({
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            let element = document.getElementById('firstFocusableObjectMindMapMenu');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    shouldComponentUpdate(newProps) {
        if (this.props.accordionWidth != newProps.accordionWidth || this.props.type != newProps.type || this.props.contextTarget != newProps.contextTarget || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight)
            return true;
        else
            return false;
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        const shapeModel = this.props.contextTarget;
        let elements = [];
        let componentProperties = {};

        elements.push(<Button accordionWidth={this.props.accordionWidth} index={0} key={'element1'} shapeModel={shapeModel} dispatch={this.props.dispatch} />);
        elements.push(<Button accordionWidth={this.props.accordionWidth} index={1} key={'element2'} shapeModel={shapeModel} dispatch={this.props.dispatch} />);


        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - 10;
        componentProperties.top = properties.CLIPART_BUTTON_HEIGHT;
        componentProperties.displayState = 'block';
        componentProperties.elements = elements;
        componentProperties.scrollHeight = (2 * 154) + 20;

        return (
            <div id="mindMapMenu" style={menuStyle}>
                <Title accordionWidth={this.props.accordionWidth} type={this.props.type} />
                <ScrollableComponent componentProperties={componentProperties} />
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/MindMapMenu.js
 **/